import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { CoolHttpModule } from '@angular-cool/http';
import { HelpSiteService } from './common/services/help-site.service';
import { ENVIRONMENT, WINDOW } from './common/services/injection-tokens';
import { environment } from '../environments/environment';
import { GlobalErrorHandler } from './common/services/logger/global-error-handler';
import { LoggerService } from './common/services/logger/logger.service';
import { StartupService } from './common/services/startup.service';
import { NgxsModule } from '@ngxs/store';
import { NgxsSelectSnapshotModule } from '@ngxs-labs/select-snapshot';
import { AppState } from './app.state';
import { CoolStorageModule } from '@angular-cool/storage';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ENVIRONMENT, useValue: environment },
    { provide: WINDOW, useValue: window },
    { provide: ErrorHandler, useClass: environment.logging?.enabled ? GlobalErrorHandler : ErrorHandler },

    provideAppInitializer(() => inject(StartupService).setupAsync()),

    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),

    importProvidersFrom(
      NgxsModule.forRoot([AppState], {
        developmentMode: !environment.production,
      }),
      NgxsSelectSnapshotModule.forRoot(),

      CoolHttpModule.forRoot(),
      CoolStorageModule.forRoot(),
    ),

    LoggerService,
    StartupService,

    HelpSiteService,
  ],
};
